import { combineReducers } from "@reduxjs/toolkit";
import { reducer as statementsReducer } from "../slices/statements";
import { reducer as accountReducer } from "../slices/accounts";
import { reducer as agreementReducer } from "../slices/agreements";
import { reducer as serviceReducer } from "../slices/services";
import { reducer as billReducer } from "../slices/bills";
import { reducer as tariffReducer } from "../slices/tariffs";
import { reducer as tenantReducer } from "../slices/tenants";
import { reducer as userReducer } from "../slices/users";
import { reducer as permissionReducer } from "../slices/permissions";
import { reducer as rolesReducer } from "../slices/roles";
import { reducer as accountsTsReducer } from "../slices/accountsTs";
import { reducer as dictReducer } from "../slices/dicts";
import { reducer as templatesReducer } from "../slices/templates";
import { reducer as reportsReducer } from "../slices/reports";
import { reducer as routingOrdersReducer } from "../slices/routingOrders/routingOrders";
import { reducer as routingPlanesReducer } from "../slices/routingPlanes/routingPlanes";
import rtkDictionaries from "../slices/rtkDictionaries";
import balance from "../slices/balance";
import payments from "../slices/payments";
import tasks from "../slices/tasks";
import xlsExport from "../slices/xlsExport";
import charges from "../slices/charges";
import rejected from "../slices/rejected-traffic";
import currencies from "../slices/currencies";
import invoices from "../slices/invoices";
import loadingStatus from "../slices/loadingStatus";
import serviceProfile from "../slices/service-profile";
import serviceTypes from "../slices/service-types";
import tenantsAdmin from "../slices/tenants-admin";
import properties from "../slices/properties";
import links from "../slices/links";
import { reducer as accumulators } from "../slices/accumulators";
import propertyTypesAdmin from "../slices/property-type-admin";
import settings from "../slices/settings";
import config from "../slices/config";
import { individualTariffsReducer } from "../slices/individualTariffs";
import { offeringReducer } from "../slices/offering/offering";
import { productsReducer } from "../slices/products/products";
import { taxTsReducer } from "../slices/taxTs";
import { destinationsReducer } from "../slices/destinations/destinations";
import { agreementsSearchReducer } from "../slices/agreementsSearch/agreementsSearch";
import { reducer as documentTemplates } from "../slices/documentTemplates";
import blocking from "../slices/blocking";
import { policiesReducer } from "../../modules/policies/store/slice/policiesSlice";
import { offeringGroupsReducer } from "../../modules/policies/store/slice/offeringGroupsSlice";
import { characteristicsReducer } from "../../modules/policies/store/slice/characteristicsSlice";
import { typesCharacteristicsReducer } from "../../modules/TypesCharacteristics/store/slice/typesCharacteristicsSlice";
import { typesCharacteristicsObjectReducer } from "../../modules/TypesCharacteristicsObject/store/slice/typesCharacteristicsSlice";
import { aggregationRulesReducer } from "../../modules/AggregationRules/store/slice/aggregationRulesSlice";
import { accountPaymentDetailsReducer } from "../../modules/AccountPaymentDetails/model/slice/accountPaymentDetailsSlice";
import { reducer as glsTasksReducer } from "../slices/glsTasks";


export default combineReducers({
  statements: statementsReducer,
  documentTemplates,
  agreements: agreementReducer,
  accounts: accountReducer,
  service: serviceReducer,
  bills: billReducer,
  tariffs: tariffReducer,
  individualTariffs: individualTariffsReducer,
  taxTs: taxTsReducer,
  offering: offeringReducer,
  products: productsReducer,
  destinations: destinationsReducer,
  tenants: tenantReducer,
  users: userReducer,
  permissions: permissionReducer,
  roles: rolesReducer,
  dicts: dictReducer,
  reports: reportsReducer,
  templates: templatesReducer,
  routingOrders: routingOrdersReducer,
  routingPlanes: routingPlanesReducer,
  tasks,
  balance,
  payments,
  accountPaymentDetails: accountPaymentDetailsReducer,
  rtkDictionaries,
  xlsExport,
  charges,
  rejected,
  invoices,
  loadingStatus,
  currencies,
  serviceProfile,
  serviceTypes,
  tenantsAdmin,
  properties,
  propertyTypesAdmin,
  accountsTs: accountsTsReducer,
  settings,
  accumulators,
  links,
  config,
  agreementsSearch: agreementsSearchReducer,
  blocking,
  policies: policiesReducer,
  offeringGroups: offeringGroupsReducer,
  characteristics: characteristicsReducer,
  typesCharacteristics: typesCharacteristicsReducer,
  typesCharacteristicsObject: typesCharacteristicsObjectReducer,
  aggregationRules: aggregationRulesReducer,
  glsTasks: glsTasksReducer,
});
